import { ComponentProps } from "react";
import * as S from "./styles";

interface ITextInputProps extends ComponentProps<"textarea"> {}
export const TextInput = (props: ITextInputProps) => {
  const valueLength =
    typeof props?.value === "string" ? props?.value?.length : 0;

  return (
    <S.WrapperTextInput>
      <S.TextInputItem {...props} />
      <p>
        Caracteres: <span>{valueLength || "000"}</span>
      </p>
    </S.WrapperTextInput>
  );
};
